import { twMerge } from 'tailwind-merge';
import { useTranslation } from 'react-i18next';

import { Button } from '../button';

import { StepPaginationProps } from './types';

export const StepPagination = ({
  hasSteps,
  className,
  backTitle,
  handleBack,
  handleNext,
  isLastStep,
  isFirstStep,
  handleFinish,
  isNextDisabled,
  isFinishDisabled,
}: StepPaginationProps) => {
  const { t } = useTranslation(['common']);
  return (
    <div className={twMerge('flex', className)}>
      {hasSteps && !isFirstStep && (
        <Button
          variant="outlined"
          onClick={handleBack}
          className="min-w-[120px]"
        >
          {backTitle || t('back')}
        </Button>
      )}
      {hasSteps && !isLastStep && (
        <Button
          onClick={handleNext}
          disabled={isNextDisabled}
          className="ml-auto min-w-[120px]"
        >
          {t('next')}
        </Button>
      )}
      {isLastStep && (
        <Button
          onClick={handleFinish}
          disabled={isFinishDisabled}
          className="ml-auto min-w-[120px]"
        >
          {t('finish')}
        </Button>
      )}
    </div>
  );
};
